
import { Link } from 'react-router-dom';

const TimelinePreview = () => {
  const timelineEvents = [
    {
      year: '1905',
      description: '生於江蘇吳縣。理學背景出身，畢業於上海聖約翰大學化學系。'
    },
    {
      year: '1938–1945',
      description: '任福建省財政廳長，創立田賦改徵實物制度，改善糧政，後為全國採用。'
    },
    {
      year: '1945–1947',
      description: '戰後奉派來臺主持財政與交通接收，擔任臺灣銀行首任董事長，建立新經濟秩序。'
    },
    {
      year: '1949',
      description: '主導幣制改革與新臺幣發行，有效抑制通膨，奠定金融穩定基礎。'
    },
    {
      year: '1950–1953',
      description: '推動土地改革與中央預算制度，建立透明財政。'
    },
    {
      year: '1954–1957',
      description: '任臺灣省主席，興建基礎建設並創立退輔會制度。'
    },
    {
      year: '1958',
      description: '推動外匯自由化與單一匯率制度，促進對外貿易。'
    },
    {
      year: '1960',
      description: '制定《獎勵投資條例》，吸引外資，帶動工業化與出口。'
    },
    {
      year: '1963–1966',
      description: '任行政院長，組成財經技術內閣，整合李國鼎、孫運璿等人才，推動出口導向政策。'
    },
    {
      year: '1966',
      description: '創設高雄加工出口區，開啟台灣外銷製造模式。'
    },
    {
      year: '1975',
      description: '蔣中正逝世後繼任總統，倡導廉政與文化復興運動。'
    },
    {
      year: '1993',
      description: '辭世於台北，享年88歲，被尊稱為『新臺幣之父』。'
    }
  ];

  return (
    <section id="biography" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#1C1C1C] mb-4">嚴家淦先生生平事蹟</h2>
            <p className="text-lg text-gray-600">(1905–1993)新臺幣之父的傳奇一生</p>
          </div>

          <div className="relative">
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-[#C2A97A]"></div>
            
            <div className="space-y-8">
              {timelineEvents.map((event, index) => (
                <div key={index} className="relative flex items-start">
                  <div className="absolute left-6 w-4 h-4 bg-[#C2A97A] rounded-full border-4 border-white shadow-lg"></div>
                  <div className="ml-16 bg-gray-50 rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
                    <div className="flex flex-col md:flex-row md:items-center md:space-x-4">
                      <div className="flex-shrink-0 mb-2 md:mb-0">
                        <span className="inline-block bg-[#C2A97A] text-white px-3 py-1 rounded-full text-sm font-semibold">
                          {event.year}
                        </span>
                      </div>
                      <p className="text-gray-700 leading-relaxed flex-1">
                        {event.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TimelinePreview;
